import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/global-factor-rules')({
  beforeLoad: () => getTitleContextSlice('Global Factor Rules'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
